import { Component } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'app-custom-toast',
  templateUrl: './custom-toast.component.html',
  styleUrls: ['./custom-toast.component.css'],
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0, transform: 'translateY(-10px) scale(0.97)' })),
      state('active',   style({ opacity: 1, transform: 'translateY(0)     scale(1)' })),
      state('removed',  style({ opacity: 0, transform: 'translateY(-8px)  scale(0.97)' })),
      transition('inactive => active', animate('280ms cubic-bezier(0.16, 1, 0.3, 1)')),
      transition('active => removed',  animate('180ms ease-in')),
    ]),
  ],
})
export class CustomToastComponent extends Toast {
  constructor(toastrService: ToastrService, toastPackage: ToastPackage) {
    super(toastrService, toastPackage);
  }

  get icon(): string {
    switch (this.toastPackage.toastType) {
      case 'toast-success': return 'ti-check';
      case 'toast-error':   return 'ti-close';
      case 'toast-warning': return 'ti-alert';
      default:              return 'ti-info-alt';
    }
  }

  get label(): string {
    switch (this.toastPackage.toastType) {
      case 'toast-success': return 'Success';
      case 'toast-error':   return 'Error';
      case 'toast-warning': return 'Warning';
      default:              return 'Info';
    }
  }

  get typeClass(): string {
    return this.toastPackage.toastType;
  }
}
